import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'app-form-group-number-input',
    templateUrl: './form-group-number-input.component.html',
    styleUrls: ['./form-group-number-input.component.scss'],
    standalone: false
})
export class FormGroupNumberInputComponent implements OnInit {

  @Input()
  label: string;

  @Input()
  model = 0;

  @Input()
  offset = 1;

  @Input()
  disableInput = true;

  @Input()
  max: number;

  @Output()
  modelChange: EventEmitter<any> = new EventEmitter<any>();

  constructor() { }

  ngOnInit() {
  }

  changeValueClickEvent(negative) {
    this.model = (negative ? (this.model - this.offset) : (this.model + this.offset));
    if (this.max && this.model > this.max) {
      this.model = this.max;
    }
    this.modelChange.emit(this.model);
  }

}
